// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';

// Global styles (Tailwind/DGA)
import './theme.css';
import './layout/dga_v2/dga-v2.css';
import './index.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Note: Fonts are loaded via Google Fonts in public/index.html

// Hugeicons Pro: activate license if configured.
// If not configured, icons may render blank (we also have a component-level fallback).
import { hugeiconsLicense } from "@hugeicons/react-pro";

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Set Arabic language and RTL direction
document.documentElement.setAttribute('lang', 'ar');
document.documentElement.setAttribute('dir', 'rtl');

try {
  const key = process.env.REACT_APP_HUGEICONS_LICENSE;
  if (key) {
    hugeiconsLicense(key);
    // Let components know Pro icons are licensed/enabled.
    window.__HUGEICONS_LICENSED__ = true;
  } else {
    // Hugeicons Pro icons render blank without a license key.
    // We keep the app running (and the UI falls back to Bootstrap icons).
    // eslint-disable-next-line no-console
    console.warn("[hugeicons] Missing REACT_APP_HUGEICONS_LICENSE; using fallback icons.");
  }
} catch (e) {
  // Keep app booting even if license activation fails.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <BrowserRouter basename="/">
    <App />
  </BrowserRouter>
);

reportWebVitals();
